import { formatLocalVersion } from '@w/utils'
import type { TelResources } from './tel-types'

declare global {
  var APP_VERSION: string
}

// Display build time, HEAD and runner appSha in UI and telemetry
globalThis.APP_VERSION = formatLocalVersion(
  typeof APP_VERSION === 'undefined' ? undefined : APP_VERSION,
)

export const createTelResource = (d: {
  name: string
  origin: 'client' | 'server'
  env: string
}): TelResources => {
  const deploy = {
    ...d,
    version: globalThis.APP_VERSION,
  }

  return {
    deploy,
    metrics: {
      name: d.name,
      env: d.env,
      origin: d.origin,
    },
  }
}
